// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bea_a bik_ke","ListItemIcon--empty":"bea_b bik_fl"};